<template>

<div class="affinity-list">

	<div class="affinity-row" v-for="(item, index) in items" :key="index" v-on:click="$emit('select', item)" v-tooltip="'View ' + item.name + ' games'">

		<div class="affinity-row-head">

			<div class="affinity-row-name">{{ item.name }}<span class="affinity-row-type" v-if="mixed">{{ item.type }}</span></div>

			<div class="affinity-row-score" :class="scoreClass(item.score)">

				<span v-if="item.score !== null && item.score > 0">+{{ item.score }}</span>
				<span v-else-if="item.score !== null">{{ item.score }}</span>
				<span v-else>—</span>

			</div>

		</div>

		<div class="affinity-row-signals">

			<div class="affinity-signal" v-if="item.ratingDelta !== null">

				<div class="affinity-signal-label">Rating</div>

				<div class="affinity-signal-value" :class="deltaClass(item.ratingDelta)">{{ item.ratingDelta > 0 ? '+' : '' }}{{ item.ratingDelta }}</div>

				<div class="affinity-signal-detail">{{ item.avgRating }} avg</div>

			</div>

			<div class="affinity-signal" v-if="item.playRatio !== null">

				<div class="affinity-signal-label">Plays</div>

				<div class="affinity-signal-value" :class="ratioClass(item.playRatio)">{{ item.playRatio }}x</div>

			</div>

			<div class="affinity-signal" v-if="item.durationRatio !== null">

				<div class="affinity-signal-label">Kept</div>

				<div class="affinity-signal-value" :class="ratioClass(item.durationRatio)">{{ item.durationRatio }}x</div>

			</div>

			<div class="affinity-signal" v-if="item.gameRatingRank !== null">

				<div class="affinity-signal-label">Rank</div>

				<div class="affinity-signal-value" :class="rankClass(item.gameRatingRank, item.gameRatingOf)">#{{ item.gameRatingRank }}<span class="affinity-signal-faint">/{{ item.gameRatingOf }}</span></div>

			</div>

		</div>

		<div class="affinity-row-bar">

			<div class="affinity-row-bar-fill" :class="scoreClass(item.score)" :style="barStyle(item.score)" />

			<div class="affinity-row-bar-center" />

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['items', 'baselines', 'your', 'you', 'colour'],

	computed: {

		mixed: function() {

			if (!this.items || this.items.length < 2) return false

			var first = this.items[0].type

			for (var i = 1; i < this.items.length; i++) {

				if (this.items[i].type !== first) return true

			}

			return false

		}

	},

	methods: {

		scoreClass: function(score) {

			if (score === null) return 'is-neutral'
			if (score >= 10) return 'is-positive'
			if (score <= -10) return 'is-negative'
			return 'is-neutral'

		},

		deltaClass: function(delta) {

			if (delta > 0.3) return 'is-positive'
			if (delta < -0.3) return 'is-negative'
			return 'is-neutral'

		},

		ratioClass: function(ratio) {

			if (ratio >= 1.2) return 'is-positive'
			if (ratio <= 0.8) return 'is-negative'
			return 'is-neutral'

		},

		rankClass: function(rank, of) {

			if (of <= 1) return 'is-neutral'
			var pct = rank / of
			if (pct <= 0.25) return 'is-positive'
			if (pct >= 0.75) return 'is-negative'
			return 'is-neutral'

		},

		barStyle: function(score) {

			if (score === null) return { width: '0%', left: '50%' }

			var clamped = Math.max(-40, Math.min(40, score))
			var pct = Math.abs(clamped) / 40 * 50

			if (clamped >= 0) {

				return { width: pct + '%', left: '50%' }

			}

			return { width: pct + '%', right: '50%', left: 'auto' }

		}

	}

}

</script>

<style scoped>

.affinity-list {
	width: 100%;
}

.affinity-row {
	min-height: 64px;
	padding: 8px 15px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.affinity-row:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.affinity-row:hover {
	background-color: rgba(72, 129, 187, 0.1);
}

.affinity-row-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 4px;
}

.affinity-row-name {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.affinity-row-type {
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	color: #999;
	margin-left: 6px;
}

.affinity-row-score {
	font-size: 18px;
	font-weight: 700;
	flex-shrink: 0;
	margin-left: 10px;
}

.affinity-row-score.is-positive { color: #2FC482; }
.affinity-row-score.is-negative { color: #c0392b; }
.affinity-row-score.is-neutral { color: #999; }

.affinity-row-signals {
	display: flex;
	justify-content: space-between;
	margin-bottom: 6px;
}

.affinity-signal {
	display: flex;
	align-items: baseline;
	gap: 3px;
}

.affinity-signal:first-child {
	justify-content: flex-start;
}

.affinity-signal:last-child {
	justify-content: flex-end;
}

.affinity-signal-label {
	font-size: 11px;
	color: #999;
	font-weight: 400;
}

.affinity-signal-value {
	font-size: 12px;
	font-weight: 700;
}

.affinity-signal-value.is-positive { color: #2FC482; }
.affinity-signal-value.is-negative { color: #c0392b; }
.affinity-signal-value.is-neutral { color: #666; }

.affinity-signal-detail {
	font-size: 11px;
	color: #999;
}

.affinity-signal-faint {
	font-weight: 400;
	color: #999;
}

.affinity-row-bar {
	height: 4px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 2px;
	position: relative;
}

.affinity-row-bar-fill {
	position: absolute;
	top: 0;
	height: 100%;
	border-radius: 2px;
}

.affinity-row-bar-fill.is-positive { background-color: #2FC482; }
.affinity-row-bar-fill.is-negative { background-color: #c0392b; }
.affinity-row-bar-fill.is-neutral { background-color: #ccc; }

.affinity-row-bar-center {
	position: absolute;
	top: -2px;
	left: 50%;
	width: 2px;
	height: 8px;
	background-color: rgba(0, 0, 0, 0.15);
	transform: translateX(-50%);
}

</style>
